export default __webpack_public_path__ + "static/media/ic_news_noti.76b8f1f0.svg";